

import React, {useEffect, useState} from 'react';
import axios from 'axios'
import "./FeaturedCourses.css"
import { Link } from 'react-router-dom';
import { fab,faFacebook, faTwitter,faInstagram,faYoutube, faLinkedin, faArrowRight, faChevronRight } from '@fortawesome/free-solid-svg-icons'
import {faHeart,faPhone,faLocationPin,faTools,faUserShield ,faTimes,faBars } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon, } from '@fortawesome/react-fontawesome';
import useContentful from '../Hooks/useContentful';

import { useParams } from 'react-router-dom';

import img1 from "../../Images/CourseGenereric.jpg"
//import img1 from "../../Images/Landing.jpg"
//import { ToastContainer } from 'react-toastify';
//use ToastContainer theme="dark"   



// import { toast } from 'react-toastify'
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';




function FeaturedCourses() { 

    const [file, setFile] = useState()
    const [courses, setCourses] = useState();

    console.log()

    // useEffect(() => {
    //     console.log("HI 2") 
    //     toast.success("Component loaded"); // Check if this works on load
    //   }, []);
    
    let {BID} = useParams()
    useEffect(()=>{

        
        console.log("HI") 
        console.log(process.env.REACT_APP_BASEURL+'/api/courses/') 
        
       async function getCourses (){ 
            
          try{      

            const response =   await axios.get(process.env.REACT_APP_BASEURL+'/api/courses/')


            console.log("am in useffect")

            // if (courses){

              if(response && response?.status == 200){ 

                  console.log("Courses",response.data)
                  setCourses(response?.data);

              } else{
                setCourses(coursesType)
                console.log("courses",courses)
              }
             
            // }

          }catch(e){
            setCourses(coursesType)
                console.log("courses",courses)
                // console.log("catch error",e)
          }
             

       }
       
        //  Async response = axios.get('http://localhost:8800/Books')

        getCourses()
         

    },[])

    const HandleFile = (e) =>{
        setFile(e.target.files[0])
    }


    const handleSubmit = () => {
        console.log("courses")
        toast.success("Form submitted successfully 2");
      };

    // const convertBlobToBase64 = (blob) => {
    //     return new Promise((resolve, reject) => {
    //       const reader = new FileReader();
    //       reader.onloadend = () => resolve(reader.result);
    //       reader.onerror = reject;
    //       reader.readAsDataURL(blob);
    //     });
    //   };
    // ...

// const convertBlobToBase64 = (blob) => {
//     return new Promise((resolve, reject) => {
//       const reader = new FileReader();
//       reader.onloadend = () => resolve(reader.result);
//       reader.onerror = reject;
//       reader.readAsDataURL(new Blob([blob]));
//     });
//   };
  
  // ...
  
    
    const HandleUpload = (e) =>{
        
        const formdata = new FormData();
        formdata.append('image',file);
        axios.post(process.env.REACT_APP_BASE_URL+'/upload',formdata)
        .then(
            // res => console.log(res)
         res =>{  if(res.data.status = "Success"){

                        console.log("ops succesful")
                    }else{

                        
                        console.log("Failed!")

                    }
        }
            
        )
        .catch(err => console.log(err))
    }

    const coursesType = [
        {
            "CourseName " : "Monitoring and Evaluation",
            "CourseCode " : "DS110",
            "Category " : "Digital Marketing Strategy",
            "CategoryTwo " : "Digital Marketing Strategy",
            "CategoryThree " : "Digital Marketing Strategy",
            "Lecturer" : "Professor Jere Mulenga",
            "Pretext" : "Develop digital marketing strategies that reach and retain customers",
            "Duration_Weeks" : "4",
            "HourlyDuration" : "6 - 7",
            "EnrollDeadline" : "January 14",
            "Cost" : "2500",
            "Price" : "1750",
            "Image" :"",
            "Description" :"Now than ever before organizations are more likely to receive funding if they can",
            "DescriptionTwo" :"E-Views offers a wide range of features for data manipulation, statistics and econometric analysis, as well as for forecasting, simulations and analytical presentations of data. E-Views is used to estimate and run the different models for estimation and prediction. The course introduces a participant to the various techniques, and means of how to upload data and interpret results. The course aims to familiarize one with background knowledge on data analysis using E-Views. The course is designed "
        },
        {
            "CourseName " : "Microsoft Project Management (for tracking)",
            "CourseCode " : "ADM200",
            "Category " : "Digital Marketing Strategy",
            "CategoryTwo " : "Digital Marketing Strategy",
            "CategoryThree " : "Digital Marketing Strategy",
            "Lecturer" : "Professor Jere Mulenga",
            "Pretext" : "Develop digital marketing strategies that reach and retain customers",
            "Duration_Weeks" : "2",
            "HourlyDuration" : "6 - 7",
            "EnrollDeadline" : "January 14",
            "Cost" : "2000",
            "Price" : "1750",
            "Image" :"",
            "DescriptionTwo" :"The course will allow the participants to master the basics of excel. The course is designed for beginners who want to learn how to create and edit spreadsheets, perform basic calculations using formulas and functions, sort, filter analyze and visualize detailed data. ",
            "Description" :"Microsoft Project management computer application/learning "
        },
        {
            "CourseName " : "Introduction to Microsoft Excel",
            "CourseCode " : "ADM100",
            "Category " : "Digital Marketing Strategy",
            "CategoryTwo " : "Digital Marketing Strategy",
            "CategoryThree " : "Digital Marketing Strategy",
            "Lecturer" : "Professor Jere Mulenga",
            "Pretext" : "Develop digital marketing strategies that reach and retain customers",
            "Duration_Weeks" : "2",
            "HourlyDuration" : "6 - 7",
            "EnrollDeadline" : "January 14",
            "Cost" : "1500",
            "Price" : "1750",
            "Image" :"",
            "Description" :"The course will allow the participants to master the basics of excel. The course is designed for beginners who want to learn how to create and edit spreadsheets, perform basic calculations using formulas and functions, sort, filter analyze and visualize detailed data. ",
            "DescriptionTwo" :"Microsoft Project management computer application/learning "
        },
        {
            "CourseName " : "Intro. NVivo for Qualitative Data Analysis",
            "CourseCode " : "DS100",
            "Category " : "Digital Marketing Strategy",
            "CategoryTwo " : "Digital Marketing Strategy",
            "CategoryThree " : "Digital Marketing Strategy",
            "Lecturer" : "Professor Jere Mulenga",
            "Pretext" : "Develop digital marketing strategies that reach and retain customers",
            "Duration_Weeks" : "1",
            "HourlyDuration" : "6 - 7",
            "EnrollDeadline" : "January 14",
            "Cost" : "1000",
            "Price" : "1750",
            "Image" :"",
            "Description" :"Qualitative researchers now have the option to apply technology tools in their approach for data management and data analysis to ease the complexity of the research process. NVivo is one such powerful software for the qualitative analysis of text, audio, video, survey and social media data.",
            "DescriptionTwo" :"Qualitative researchers now have the option to apply technology tools in their approach for data management and data analysis to ease the complexity of the research process. NVivo is one such powerful software for the qualitative analysis of text, audio, video, survey and social media data. The course is going to be a five-day course with an aim of providing a comprehensive overview of NVivo and an opportunity for participants to analyse qualitative data for their own projects. The course will p "
        },
        {
            "CourseName " : "Digital Marketing",
            "CourseCode " : "MKT100",
            "Category " : "Digital Marketing Strategy",
            "CategoryTwo " : "Digital Marketing Strategy",
            "CategoryThree " : "Digital Marketing Strategy",
            "Lecturer" : "Professor Jere Mulenga",
            "Pretext" : "Develop digital marketing strategies that reach and retain customers",
            "Duration_Weeks" : "3",
            "HourlyDuration" : "6 - 7",
            "EnrollDeadline" : "January 14",
            "Cost" : "2000",
            "Price" : "1750",
            "Image" :"",
            "Description" :"In this hands-on and interactive course, you will dive into the core components of digital marketing, gaining practical skills and knowledge essential for today's business environment. From understanding the fundamentals of online advertising to harnessing the power of social media and analytics, this course covers it all.",
            "DescriptionTwo" :"In this hands-on and interactive course, you will dive into the core components of digital marketing, gaining practical skills and knowledge essential for today's business environment. From understanding the fundamentals of online advertising to harnessing the power of social media and analytics, this course covers it all."
        },
        {
            "CourseName " : "Data Analysis in E-Views",
            "CourseCode " : "MKT110",
            "Category " : "Digital Marketing Strategy",
            "CategoryTwo " : "Digital Marketing Strategy",
            "CategoryThree " : "Digital Marketing Strategy",
            "Lecturer" : "Professor Jere Mulenga",
            "Pretext" : "Develop digital marketing strategies that reach and retain customers",
            "Duration_Weeks" : "2",
            "HourlyDuration" : "6 - 7",
            "EnrollDeadline" : "January 14",
            "Cost" : "1500",
            "Price" : "1750",
            "Image" :"",
            "Description" :"E-Views offers a wide range of features for data manipulation, statistics and econometric analysis, as well as for forecasting, simulations and analytical presentations of data.",
            "DescriptionTwo" :"Qualitative researchers now have the option to apply technology tools in"
        },
   
    ]

    // const [authors, setAuthors] = useState([]);
    // const { getAuthors } = useContentful();
  
    // useEffect(() => {
    //     console.log("Hello")
    //   getAuthors().then((response) => console.log("ressedagt",response));
    // //   getAuthors().then((response) => response && setAuthors(response));
    // },[]);
  

  
 

  return <>
        <div className='featuredWholeCover'>    

                <div className='CMSWording'>
                        
                        <h3 className="solidLine">FEATURED COURSES </h3>

                </div>

        <div className='CourseCardsGrid'>   
            {(courses && courses.length) ? courses.map((index,key)=>{
                 return(
                    <>          
                 <Link className='LinkItems' to={`/Courses/${index?.CourseCode}`}>
                <div key={index} className='courseWholeCover'>

                <div className='FeaturedWholeNewCard'>

                        <div className='courseImg'>

                        <img src={img1} />
                        
                </div>  



                <div className='workingWholeCover'> 

                <div className='courseWording'>

                <div className='Heading'><h2>{index?.CourseName}</h2></div>
                <div className='Pretext'> <p>{String(index?.Description).slice(0, 150) + '...'}</p></div>

                </div>
                <div className='courseMetrics'>

                        <div className='enrollDuration'>
                                <p>{`${index?.Duration_Weeks} week(s) , 3 - 5 hrs/week`}</p>
                        </div>
                        <div className='enrollhrs'>
                                
                        </div>
                            <div className='enrollDeadline'> 

                                        <p>Apply for the next cohort</p>
                                </div>
                                <div className='enrollPrice'>

                                        {/* <p><b>{`ZMK ${index?.Cost} (four installments of ZMK ${index?.Cost/4})`}</b></p> */}
                                        <p><b>{`ZMK ${index?.Cost}`}</b></p>
                                       
                                        <p><button className='viewCourse'>View Course</button></p>

                                </div>
                    
                        </div>

                    </div>

                    

                </div>

                </div>
                </Link>
          

                          
                           
                    </>
                 )
                 
            }): null}
            
         
        </div>
        <div className='CourseCardsGrid'>   
        {(courses && !(courses)) ? coursesType.slice(0, 3).map((index,key)=>{
                 return(
                    <>          
                 <Link className='LinkItems' to={`/Courses${index?.CourseCode}`}>
                <div key={index} className='courseWholeCover'>

                <div className='FeaturedWholeNewCard'>

                        <div className='courseImg'>

                        <img src={img1} />
                        
                </div>  



                <div className='workingWholeCover'> 

                <div className='courseWording'> 

                <div className='Heading'><h2>{index?.CourseName}</h2></div>
                
                <div className='Pretext'> <p>{String(index?.Description).slice(0, 150) + '...'}</p></div>
                

                </div>
                <div className='courseMetrics'>

                        <div className='enrollDuration'>
                                <p>{`${index?.Duration_Weeks} week(s) , 3 - 4 hrs/week`}</p>
                        </div>
                        <div className='enrollhrs'>
                                
                        </div>
                            <div className='enrollDeadline'> 

                                        <p>Apply by December 1</p>
                                </div>
                                <div className='enrollPrice'>

                                        <p><b>{`ZMK ${index?.Cost} (four installments of ZMK ${index?.Cost/4})`}</b></p>

                                </div>
                    
                        </div>

                    </div>

                    

                </div>

                </div>
                </Link>
             

                
           
             
                                    


                        
                           
                    </>
                 )
                 
            }): null}
        
         
        </div>

                <div className='exploreCourses'>

                        {/* <div className='exploreCover' onClick={handleSubmit}> */}
                        <div className='exploreCover'>
                              
                              <p>Explore All Courses</p>
                              <ToastContainer />
                            
                              <FontAwesomeIcon className="fontawesomIconhere" icon={faChevronRight} />

                        </div>

                </div>


           

    
        </div>
        
       
    
  </>
  
  ;
}

export default FeaturedCourses;